export default __webpack_public_path__ + "static/media/watch3.5872c545.jpg";